import React from "react";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/footer";

function RefundPage(props) {
  return (
    <div>
      <div className="nav_container">
        <Navbar fromPage="refundpage" />
      </div>
      <div className="bg_img_blog">
        <section className="main_blog_view_container">
          <div className="blog_view_section_under_contianer">
            <div className="terms_container">
              <div className="head">
                <h2>REFUND &amp; CANCELLATION POLICY :</h2>
              </div>
              <div>
                <p>
                  Our aim is to assure and deliver customer satisfaction. It is
                  our endeavor that if you are displeased/ dissatisfied with the
                  rendered services, we offer a refund if we have missed
                  deadlines or there is any breach of service committed by one
                  of our experts after verifying the reasons of the
                  dissatisfaction. As a principle, we take strict action against
                  the expert, except issuing an immediate refund. However, if
                  the refund request is made on the base of &lsquo;change of
                  mind&rsquo;, we have a &lsquo;No Refund&rsquo;
                  policy. All services are booked and paid &ldquo;as is&rdquo;
                  basis.
                </p>
                <p>
                  We would like our users to read the description/check list of
                  our services thoroughly or speak to our counsellors before
                  making the payment. You may contact us within 30 days from
                  the complaint date if you wish to adjust the amount for
                  another service of equal or a lesser value.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default RefundPage;
